import { Link } from 'react-router-dom';
import './Legal.css';

export default function Terms() {
  return (
    <div className="terms-page">
      <div className="page-hero">
        <div className="container">
          <div className="badge">Legal</div>
          <h1>Terms & Conditions</h1>
          <p>The terms that govern your use of the Aarambh platform.</p>
        </div>
      </div>

      <section className="legal-section">
        <div className="container legal-card">
          <p className="legal-updated">Last updated: 7 August 2026</p>

          <p className="legal-intro">
            These Terms & Conditions ("Terms") govern your access to and use of the Aarambh platform,
            including our website, mandal registration, donation and events features (collectively, the
            "Platform"). By accessing or using the Platform, you agree to be bound by these Terms. If you do
            not agree, please do not use the Platform.
          </p>

          <div className="legal-block">
            <h2>1. About Aarambh</h2>
            <p>
              Aarambh (आरंभ) is a community platform that connects Ganpati Mahotsav Mandals in Valsad
              district, Gujarat, enabling mandal registration, donation collection and coordination of social
              and cultural activities.
            </p>
          </div>

          <div className="legal-block">
            <h2>2. Eligibility</h2>
            <p>
              Mandal registration is intended for Sarvajanik Ganesh Mahotsav Mandals operating within Valsad
              district. By registering, you confirm that you are authorised to represent the mandal and that
              all information provided is true, accurate and current. Donors and visitors using the Platform
              must be at least 18 years of age or use the Platform under the supervision of a parent/guardian.
            </p>
          </div>

          <div className="legal-block">
            <h2>3. Mandal Registration & Approval</h2>
            <p>
              Submitting a mandal registration does not guarantee listing on the Platform. All registrations
              are subject to review and approval by Aarambh administrators. We reserve the right to request
              additional information, reject an application, or remove/suspend a mandal's listing at our
              discretion — including where information provided is found to be inaccurate, misleading or in
              violation of these Terms.
            </p>
          </div>

          <div className="legal-block">
            <h2>4. Compliance for Social & Community Activities</h2>
            <p>
              All social, environmental, and community welfare activities shall be undertaken voluntarily and
              in compliance with all applicable Government rules, regulations, guidelines, and permissions.
            </p>
            <p lang="hi">
              सभी सामाजिक, पर्यावरण संरक्षण एवं जनकल्याण संबंधी गतिविधियाँ स्वैच्छिक रूप से तथा सभी लागू
              सरकारी नियमों, विनियमों, दिशानिर्देशों एवं आवश्यक अनुमतियों का पालन करते हुए की जाएँगी।
            </p>
          </div>

          <div className="legal-block">
            <h2>5. Account & Portal Access</h2>
            <p>
              Registered mandals and administrators are provided login credentials to access the mandal or
              admin portal. You are responsible for maintaining the confidentiality of your login credentials
              and for all activity that occurs under your account. Please notify us immediately if you suspect
              unauthorised access to your account.
            </p>
          </div>

          <div className="legal-block">
            <h2>6. User-Submitted Content</h2>
            <p>
              Mandals may submit content such as logos, photographs, event descriptions and other materials
              ("User Content"). By submitting User Content, you confirm that you own or have the necessary
              rights to it, and you grant Aarambh a non-exclusive, royalty-free licence to display, reproduce
              and distribute this content on the Platform for the purpose of promoting your mandal and its
              activities. We reserve the right to remove any User Content that is inappropriate, unlawful, or
              violates these Terms.
            </p>
          </div>

          <div className="legal-block">
            <h2>7. Donations</h2>
            <ul>
              <li>All donations made through the Platform are voluntary contributions towards the cause selected by the donor at the time of donation.</li>
              <li>Donations are used to support Ganesh Utsav celebrations, medical and health camps, community welfare initiatives and environmental activities, in line with the cause chosen.</li>
              <li>A donation receipt/acknowledgement is issued for each successful donation. Tax exemption receipts (where applicable) are subject to the trust's valid registration and applicable regulations in force at the time of donation.</li>
              <li>Donations are generally non-refundable. In the event of a duplicate charge, payment error, or technical failure where an amount was debited but the donation was not successfully recorded, please contact us and we will investigate and process a refund where warranted.</li>
              <li>While we strive to allocate funds transparently towards the selected cause, exact allocation may be adjusted based on the community's most pressing needs.</li>
            </ul>
          </div>

          <div className="legal-block">
            <h2>8. Payment Processing</h2>
            <p>
              Payments are processed through Razorpay, a third-party, RBI-regulated payment gateway. Aarambh
              is not responsible for outages, delays or errors caused by the payment gateway, your bank, or
              your internet service provider. Use of Razorpay's services is also subject to Razorpay's own
              terms and privacy policy.
            </p>
          </div>

          <div className="legal-block">
            <h2>9. Prohibited Conduct</h2>
            <p>You agree not to:</p>
            <ul>
              <li>Provide false, misleading or fraudulent information during registration, donation or contact submissions.</li>
              <li>Use the Platform for any unlawful purpose or in violation of any applicable law.</li>
              <li>Attempt to gain unauthorised access to any account, system or data on the Platform.</li>
              <li>Upload content that is defamatory, obscene, infringing, or that violates the rights of any third party.</li>
              <li>Interfere with or disrupt the security or proper functioning of the Platform.</li>
            </ul>
          </div>

          <div className="legal-block">
            <h2>10. Intellectual Property</h2>
            <p>
              The Aarambh name, logo, design and platform content (excluding User Content and mandal-submitted
              material) are the property of Aarambh and may not be copied, reproduced or used without prior
              written permission.
            </p>
          </div>

          <div className="legal-block">
            <h2>11. Third-Party Services & Links</h2>
            <p>
              The Platform may reference or link to third-party services (such as Razorpay and Brevo) or
              external websites. We are not responsible for the content, policies or practices of any
              third-party service or website.
            </p>
          </div>

          <div className="legal-block">
            <h2>12. Limitation of Liability</h2>
            <p>
              The Platform is provided on an "as is" and "as available" basis. To the maximum extent permitted
              by law, Aarambh, its volunteers and administrators shall not be liable for any indirect,
              incidental or consequential damages arising out of your use of, or inability to use, the
              Platform, including but not limited to loss of data, donations, or business opportunities.
            </p>
          </div>

          <div className="legal-block">
            <h2>13. Indemnification</h2>
            <p>
              You agree to indemnify and hold Aarambh, its volunteers and administrators harmless from any
              claims, damages or expenses arising from your violation of these Terms or misuse of the
              Platform.
            </p>
          </div>

          <div className="legal-block">
            <h2>14. Suspension & Termination</h2>
            <p>
              We reserve the right to suspend or terminate a mandal's registration or portal access at any
              time, with or without notice, if we reasonably believe these Terms have been violated or if
              continued access poses a risk to the Platform or its users.
            </p>
          </div>

          <div className="legal-block">
            <h2>15. Governing Law & Jurisdiction</h2>
            <p>
              These Terms are governed by the laws of India. Any disputes arising out of or relating to these
              Terms or your use of the Platform shall be subject to the exclusive jurisdiction of the courts
              at Valsad, Gujarat.
            </p>
          </div>

          <div className="legal-block">
            <h2>16. Changes to These Terms</h2>
            <p>
              We may revise these Terms from time to time. Updates will be posted on this page along with a
              revised "Last updated" date. Continued use of the Platform after changes are posted constitutes
              acceptance of the revised Terms.
            </p>
          </div>

          <div className="legal-block">
            <h2>17. Contact Us</h2>
            <p>For any questions about these Terms, please reach out to us:</p>
            <div className="legal-contact-box">
              <p><strong>Aarambh</strong></p>
              <p>Valsad, Gujarat, India</p>
              <p>Or use our <Link to="/contact">Contact Us</Link> page.</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
